'use strict';

// export this package's api
module.exports = require('./Animate');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.2.3.1@rc-animate/lib/index.js
 ** module id = 18
 ** module chunks = 0
 **/